import { BarChartDatePeriod } from './bar-chart-date-period';

export interface BarChartDate {
  period: BarChartDatePeriod;
  date: Date;
  productId: string;
  id: string;
}
